module.exports = __webpack_public_path__ + "assets/huiyiyuding.d6fe4773.svg";